import React, {useMemo} from 'react';
import type {SyntheticListenerMap} from '@dnd-kit/core/dist/hooks/utilities';
import type {UniqueIdentifier} from '@dnd-kit/core/dist/types/other';
import {useSortable} from '@dnd-kit/sortable';

export function DndSortableItem({
  id,
  renderer,
  isActive,
}: {
  id: UniqueIdentifier;
  renderer: (
    id: UniqueIdentifier,
    listeners: SyntheticListenerMap | undefined,
  ) => React.ReactNode;
  isActive?: boolean;
}) {
  const {attributes, listeners, setNodeRef, transform, transition} =
    useSortable({id: id});

  const style = useMemo(
    () => ({
      // Do this rather than CSS.Transform.toString(transform) to
      // avoid stretching/shrinking items while dragging
      transform: transform
        ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
        : undefined,

      transition,
      zIndex: isActive ? 999 : undefined,
    }),
    [transform, transition, isActive],
  );

  return (
    <div ref={setNodeRef} style={style} {...attributes} tabIndex={-1}>
      {renderer(id, listeners)}
    </div>
  );
}
